import { useState, useEffect } from "react";
import { CommonType, PayloadReportType } from "../../../types";
import { getParserConfigList, parserConfigReport } from "../../../services/parserConfigService";

export const useParserConfigReport = (deviceTypeId: number) => {
  const [payloadText, setPayloadText] = useState("");
  const [payloadData, setPayloadData] = useState<PayloadReportType[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedParserConfig, setSelectedParserConfig] = useState<number | "">("");
  const [parserConfigList, setParserConfigList] = useState<CommonType[]>([]);


  const fetchParserConfigList = async () => {
    try {
      const res = await getParserConfigList(deviceTypeId);
      if (res.data?.data) {
        setParserConfigList(res.data.data);
      }
    } catch (err) {
      throw new Error("Parser listesi yüklenirken hata oluştu");
    }
  };

  const handlePayloadUpload = async (payload?: string) => {
    const payloadToParse = payload ?? payloadText;

    if (!payloadToParse?.trim()) {
      throw new Error("Veri boş olamaz");
    }

    if (!selectedParserConfig) {
      throw new Error("Lütfen bir parser seçin");
    }

    try {
      setLoading(true);
      setPayloadData([]);

      const response = await parserConfigReport({
        payload: payloadToParse,
        parserConfigId: selectedParserConfig as number,
      });

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      setPayloadData(
        response.data.data.map((item: PayloadReportType) => ({
          ...item,
        }))
      );
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handlePayloadChange = (value: string) => {
    setPayloadText(value);
  };

  const handleParserConfigChange = (parserConfigId: number) => {
    setSelectedParserConfig(parserConfigId);
  };

  useEffect(() => {
    fetchParserConfigList();
  }, []);

  return {
    payloadText,
    payloadData,
    loading,
    selectedParserConfig,
    parserConfigList,
    handlePayloadChange,
    handleParserConfigChange,
    handlePayloadUpload,
  };
};
